import script from "./voluntarilyCash.vue?vue&type=script&setup=true&lang=js"
export * from "./voluntarilyCash.vue?vue&type=script&setup=true&lang=js"

import "./voluntarilyCash.vue?vue&type=style&index=0&id=424e3948&lang=scss&scoped=true"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-424e3948"]])

export default __exports__